import { render, staticRenderFns } from "./ModalPostulatedParticipants.vue?vue&type=template&id=26a6bbf8"
import script from "./ModalPostulatedParticipants.vue?vue&type=script&lang=js"
export * from "./ModalPostulatedParticipants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports